/**
	Bind multiple component methods:

	* @param {this} context
	* @param {Array} functions

	constructor() {
		...
		bindFunctions.call(this, ['handleClick', 'handleOther']);
	}
*/

"use strict";

module.exports = function bindFunctions(functions) {
	var _this = this;

	functions.forEach(function (f) {
		return _this[f] = _this[f].bind(_this);
	});
};


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/github.com+petflow+react-images@b493075cbbc68a1a48b51bede9ea2be2846996cf_75majzr67pr6dysc3w5lngjsty/~/react-images/lib/utils/bindFunctions.js
// module id = 352
// module chunks = 0